import React from 'react';
import { Text, i18n, tokens, localizationMaps } from '@simplybenefits/sb-ui-library';
import { numberWithCommas } from '../../services/helpers.js';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { Add as AddIcon, Remove as RemoveIcon } from '@mui/icons-material';

/**
 *
 * @param {*} props
 */
export default function SpendingAccounts({ classes, expanded, spendingAccounts, handleChange, defineSpendingAccountType, healthRemaining, lifestyleRemaining, lsaClaimTypes, isStudent }) {
    const half = Math.ceil(lsaClaimTypes?.length / 2);
    const left = lsaClaimTypes?.slice(0, half);
    const right = lsaClaimTypes?.slice(half, lsaClaimTypes?.length);

    let hsaRolloverString = i18n.t(tokens.labels.coverage.benefitExpiration);
    
    if (spendingAccounts.health.allowHsaRollover === 1) { 
        const maxRolloverString = spendingAccounts.health.hasMaxRollover === 1 ? i18n.t(tokens.labels.coverage.maximumRollover, { maxRollover: numberWithCommas(spendingAccounts.health.maxHsaRollover || 0) }) : '';
        hsaRolloverString = i18n.t(tokens.labels.coverage.rolloverToNextCalendarYear, { maxRolloverType: maxRolloverString });
    }

    let lsaRolloverString = i18n.t(tokens.labels.coverage.benefitExpiration); 
    if (spendingAccounts.lifestyle.allowLsaRollover === 1) { 
        const maxRolloverString = spendingAccounts.lifestyle.hasMaxRollover === 1 ? i18n.t(tokens.labels.coverage.maximumRollover, { maxRollover: numberWithCommas(spendingAccounts.lifestyle.maxLsaRollover || 0) }) : '';
        lsaRolloverString = i18n.t(tokens.labels.coverage.rolloverToNextCalendarYear, { maxRolloverType: maxRolloverString });
    }

    return (
        <div style={ classes.block }>
            <Accordion
                square
                onChange={handleChange('spendingAccounts')}
                style={{ boxShadow: 'none' }}
                disableGutters={true}
            >
                <AccordionSummary
                    classes={{
                        content: classes.panelContent,
                        expanded: classes.expanded,
                        root: classes.root
                    }}
                    expandIcon={expanded.includes('spendingAccounts') ? <RemoveIcon /> : <AddIcon />}
                    sx={classes.accordionSummary}
                >
                    <Text medium bold>{ i18n.t(tokens.titles.spendingAccounts) }</Text>
                </AccordionSummary>
                <AccordionDetails style={classes.panelDetails}>
                    {
                        spendingAccounts.meta.isEligible !== 1 ?
                            <div style={classes.row}>
                                <Text small bold margin="20px 0px 10px 0px">
                                    { i18n.t(tokens.labels.coverage.ineligibleForBenefit)}
                                </Text>
                            </div>
                            : 
                            null
                    }

                    <Text small bold margin="20px 0px 10px 0px">{ defineSpendingAccountType(spendingAccounts) }</Text>

                    <Text small bold margin="5px 0px 10px 0px">
                        { i18n.t(tokens.labels.coverage.viewCurrentBalance) }
                    </Text>
                    {
                        spendingAccounts.health.hasBenefit ?
                            <div style={classes.row}>
                                <Text small customStyle={{ flex: 1, marginBottom: 10 }}>
                                    {
                                        i18n.t(tokens.labels.coverage.healthSpendingAccount, { healthRemaining: numberWithCommas(healthRemaining) })
                                    }
                                    { ` ${ hsaRolloverString }` }
                                </Text>
                            </div>
                            : 
                            null
                    }

                    {
                        spendingAccounts.lifestyle.hasBenefit ?
                            <div style={classes.row}>
                                <Text small customStyle={{ flex: 1, marginBottom: 10 }}>
                                    { i18n.t(tokens.labels.coverage.lifestyleSpendingAccount, { lifestyleRemaining: numberWithCommas(lifestyleRemaining) }) }
                                    { ` ${ lsaRolloverString }` }
                                </Text>
                            </div>
                            : 
                            null
                    }

                    {
                        lsaClaimTypes?.length && spendingAccounts.lifestyle.hasBenefit ?
                            <React.Fragment>
                                <Text small bold margin="20px 0px 10px 0px">
                                    { i18n.t(tokens.labels.coverage.lifestyleSpendingClaims) }
                                </Text>

                                <div style={classes.spendingColumns}>
                                    <div style={classes.spendingRow}>
                                        {left.map((item) => <Text key={ item } small margin="0px 20px 0px 0px">{ localizationMaps.fromEnglish("benefits", item) }</Text>)}
                                    </div>

                                    <div style={classes.spendingRow}>
                                        {right.map((item) => <Text key={ item } small margin="0px 20px 0px 0px">{ localizationMaps.fromEnglish("benefits", item) }</Text>)}
                                    </div>
                                </div>
                            </React.Fragment>
                            : 
                            null
                    }

                    { isStudent ?
                        <Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.terminatesAtEndOfStudy, { terminationAge: spendingAccounts.meta.terminationAge }) }</Text>
                        :
                        <Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.terminatesAtAge, { terminationAge: spendingAccounts.meta.terminationAge }) }</Text>
                    }
                </AccordionDetails>
            </Accordion>
        </div>
    );
}